var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.707,
    height: 160,
    viewBox: "0 0 200.707 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d0d2d5;}.b,.e{opacity:0.1;}.c,.e{fill:#444053;}.d{fill:#fff;}.f,.g{fill:#0f4b73;}.g{opacity:0.3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-39.221 -49.582)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M514.548,753.727l-48.268-.618.143-1.238,2.332-20.422h42.39l3.118,20.422.238,1.547Z",
    transform: "translate(-350.329 -544.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M514.5,808.387H490.415l-24.135-.309.143-1.238h47.84Z",
    transform: "translate(-350.331 -599.114)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 64.049,
    height: 1.547,
    transform: "translate(107.895 208.035)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M444.407,291.836a4.376,4.376,0,0,0-4.306-4.446h-192.1a4.379,4.379,0,0,0-4.306,4.446V410.881H444.407Z",
    transform: "translate(-204.479 -237.808)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M243.7,698.6v12.7a4.165,4.165,0,0,0,4.306,4.009H440.1a4.471,4.471,0,0,0,3.045-1.173,3.872,3.872,0,0,0,1.26-2.836V698.6Z",
    transform: "translate(-204.479 -526.611)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 186.164,
    height: 97.464,
    transform: "translate(46.957 56.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M572.51,736.59l19.257,19.338-2.955-19.338Z",
    transform: "translate(-426.615 -547.893)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 186.351,
    height: 5.694,
    transform: "translate(46.821 56.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 4.952,
    height: 3.465,
    rx: 0.78,
    transform: "translate(47.81 57.391)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 51.981,
    height: 3.465,
    rx: 0.58,
    transform: "translate(113.64 57.391)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 1.734,
    cy: 1.734,
    r: 1.734,
    transform: "translate(228.963 57.388)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M494.573,413.74H430.226c-2.229,0-4.036,3.428-4.036,7.654v72.017c0,4.226,1.807,7.654,4.036,7.654h64.347c2.229,0,4.036-3.427,4.036-7.654V421.394C498.609,417.168,496.8,413.74,494.573,413.74Z",
    transform: "translate(-322.332 -349.445)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 13.181,
    height: 4.472,
    rx: 2.236,
    transform: "translate(157.423 115.669)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 13.181,
    height: 4.472,
    rx: 2.236,
    transform: "translate(157.423 109.464)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 24.712,
    height: 4.472,
    rx: 2.236,
    transform: "translate(145.555 128.939)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 13.181,
    height: 4.472,
    rx: 2.236,
    transform: "translate(157.423 121.875)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 25.067,
    height: 4.472,
    rx: 2.236,
    transform: "translate(109.363 80.366)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 46.688,
    height: 4.472,
    rx: 2.236,
    transform: "translate(109.363 86.571)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 38.04,
    height: 4.472,
    rx: 2.236,
    transform: "translate(109.363 92.776)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature3.41851e3ef82960db709575b6d752096b.svg";
export { ForwardRef as ReactComponent };